import { Link } from 'react-router-dom';
import { blogPosts } from '@/mocks/blogPosts';

const BlogSection = () => {
  const posts = blogPosts;

  return (
    <section id="blog" className="relative w-full bg-background-50 border-t border-background-200 py-14 md:py-16">
      <div className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                  <i className="ri-book-open-line text-xs"></i>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                  08 / Field Notes
                </span>
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900 max-w-3xl">
                We document everything{' '}
                <span className="block text-primary-500">we build.</span>
              </h2>
            </div>
            <p className="max-w-md text-[15px] leading-relaxed text-foreground-700">
              Engineering write-ups, project journals, and the occasional bit of press. No fluff — just what the team learned this week.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <article
                key={post.slug}
                className="group bg-background-100 border border-background-200 rounded-2xl overflow-hidden flex flex-col hover:bg-background-50 hover:border-foreground-900/30 transition-all"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    alt={post.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    src={post.image}
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-[10px] font-mono uppercase tracking-widest">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    {post.category}
                  </span>
                  <button
                    className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/95 backdrop-blur-sm border border-background-200 hover:border-foreground-900 transition-colors cursor-pointer"
                    aria-label="Bookmark"
                  >
                    <i className="ri-bookmark-line text-base text-foreground-700"></i>
                  </button>
                </div>
                <Link to={`/blog/${post.slug}`} className="p-6 flex-1 flex flex-col">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-foreground-500 mb-3 flex items-center gap-3">
                    <span>{post.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{post.readTime}</span>
                  </div>
                  <h4 className="font-display text-xl font-bold text-foreground-900 leading-snug mb-3 group-hover:text-primary-500 transition-colors">
                    {post.title}
                  </h4>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    {post.excerpt}
                  </p>
                  <div className="mt-5 pt-5 border-t border-background-200 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <img
                        alt={post.author.name}
                        className="w-8 h-8 rounded-full object-cover"
                        src={post.author.image}
                      />
                      <span className="text-sm text-foreground-700 font-medium">{post.author.name}</span>
                    </div>
                    <span className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors cursor-pointer">
                      Read <i className="ri-arrow-right-up-line text-base"></i>
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;